var Curriculog = Curriculog || {};

Curriculog.Committee = (function ($, _, Backbone, Committee) {

	Committee = Curriculog.CurriculogModel.extend({});
	return Committee;

})($, _, Backbone, Curriculog.Committee || {});
